import { Button } from "../ui/button";
import { CalendarSync, CalendarX } from "lucide-react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { format } from "date-fns";
import { srLatn } from "date-fns/locale";
import { type RouterOutput } from "~/server/api/root";
import { parseAsIsoDateTime, parseAsInteger, useQueryStates } from "nuqs";

interface TimeWarningProps {
  date?: Date;
  therapist: NonNullable<RouterOutput["therapistRouter"]["getTherapist"]>;
}

export default function TimeWarning({ date }: TimeWarningProps) {
  const [, setBookingParams] = useQueryStates({
    date: parseAsIsoDateTime,
    step: parseAsInteger,
  });

  return (
    <div className="flex w-full items-start justify-center px-4 py-8">
      <Card className="w-full max-w-md text-center shadow-lg">
        <CardHeader className="items-center">
          <CalendarX className="mb-4 h-16 w-16 text-primary" />
          <CardTitle className="text-2xl font-bold text-primary">
            Ovaj termin ne može više da se zakaže
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            Termin{" "}
            <span className="font-semibold text-foreground">
              {format(date ?? new Date(), "dd.MM.yyyy 'u' HH:mm", {
                locale: srLatn,
              })}
            </span>{" "}
            je u međuvremenu istekao ili je prošao rok za onlajn zakazivanje.
          </p>
          <p className="text-muted-foreground">
            Izaberi drugi slobodan termin.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={() => {
              void setBookingParams({ date: null, step: 0 });
            }}
            icon={CalendarSync}
            className="mt-4"
          >
            Izaberi drugi termin
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
